import CloseIcon from "../../assets/icons/CloseIcon";

/**
 * A close icon button. Useful for closing modals...
 */
const CloseButton = ({
  buttonClassName,
  iconClassName,
  onClick
}: {
  buttonClassName?: string;
  iconClassName?: string;
  onClick?: () => void;
}) => (
  <button onClick={onClick} className={buttonClassName}>
    <CloseIcon className={"stroke-ctb-grey-300 " + iconClassName} />
  </button>
);

export default CloseButton;
